import type { SnowplowContext, SnowplowSchema } from '../providers';

/**
 * Use context schema name to avoid duplicate types
 * Usage: as argument to Array.filter() method
 */
export const removeDuplicateByType = (baseList: SnowplowSchema[]) => (element: SnowplowContext) =>
	!baseList.includes(element.schema);
